import "../css/shared/header.scss";
import "../css/shared/footer.scss";
import "../css/pages/home.scss";
import "../css/pages/about.scss";
import "../css/pages/coding.scss";
import "../css/pages/tutors.scss";
import "../css/pages/sms.scss";
import "../css/pages/contact.scss";
import "../css/pages/forms.scss";